<template>
  <v-container
    id="our-philosophy"
    fluid
    class="our-philosophy"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="6"
      >
        <h2 class="text-h5 text-sm-h4 text-md-h3 font-weight-bold text-center mb-6">
          Better Together by Listening First
        </h2>
        
        <div class="content-with-floating-image">
          <div class="floating-image">
            <v-img
              :src="duck"
              alt="Yellow Listening Duck"
              max-width="400"
              class="rounded-xl"
              contain
            />
          </div>
          
          <div class="flowing-text">
            <p class="text-responsive mb-4">
              In <em>The Pragmatic Programmer</em>, there's a story about solving
              problems by talking to a rubber duck. You walk through the
              code, line by line, and in the telling you discover the flaw.
              The duck doesn't solve it—you do—because speaking forces
              clarity.
            </p>
            <p class="text-responsive mb-4">
              Yellow Duck Technologies takes that principle beyond code. In
              peer mentorship, the "duck" is a colleague who listens without
              jumping in, giving you the space to reason it out, make small
              mistakes, and learn in real time. It's the same safety culture
              that drives great DevOps: problems are surfaced early, ideas
              are tested openly, and learning is continuous.
            </p>
            <p class="text-responsive mb-4">
              We keep the duck in our name as a reminder: the fix often
              starts with the conversation. In the right
              environment—supportive, curious, and safe to speak—people
              bring out their best work. And when people get better,
              everything they build gets better too.
            </p>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import duck from "@/assets/listening_duck.webp";
</script>

<style scoped>
.our-philosophy {
  padding: 2rem 1rem;
  overflow: visible; /* Ensure container doesn't clip content */
}

.content-with-floating-image {
  position: relative;
  overflow: visible;
  min-height: 400px; /* Ensure container is tall enough for image */
}

/* Add clearfix to contain floats properly */
.content-with-floating-image::after {
  content: "";
  display: table;
  clear: both;
}

.floating-image {
  float: left;
  margin: 0 2rem 1.5rem 0;
  shape-outside: margin-box;
  width: 400px;
  max-width: 45%; /* Ensure it doesn't take too much space */
  display: flex;
  align-items: flex-start;
}

.floating-image :deep(.v-img__image) {
  background-position: center top !important; /* Ensure image starts from top */
}

.flowing-text {
  text-align: justify;
  line-height: 1.7;
}

.flowing-text p {
  margin-bottom: 1.5rem;
}

@media (max-width: 768px) {
  .floating-image {
    float: left;
    margin: 0 1rem 1rem 0;
    width: 150px;
    max-width: 40%;
  }

  .floating-image .v-img {
    max-width: 150px;
  }

  .flowing-text {
    text-align: left;
  }
}

@media (max-width: 960px) and (min-width: 769px) {
  .floating-image {
    width: 280px;
    margin-right: 1.5rem;
  }
}
</style>
